import React, { Component } from 'react';
import TextField from '../base/TextField';
class Email extends Component {
  render() {
    return (
      <div className="form-email-row">
        <TextField label="E-mail"
          name="info_email" />
        <TextField label="Re-enter E-mail address to verify"
          name="info_email_check" />
      </div>
    )
  }
}

export default Email;
